<template>
  <div>
    <div class="zcfg_list" v-if="list.length > 0">
      <div
        class="zcfg_item flex align_items_ctr"
        v-for="(item, index) in list"
        :key="index"
      >
        <div
          class="title text_overflow1 flex_1 pointer_line"
          @click="$goDetail(item)"
        >
          {{ item.title }}
        </div>
        <div class="date">{{ item.pub_date }}</div>
      </div>
    </div>
    <img
      v-else
      style="height: 229px; margin: 0 auto"
      src="../../../assets/imgs/placeholder/no_data.png"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonZcfg",
  props: ["list"],
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="less" scoped>
.zcfg_list {
  .zcfg_item {
    font-size: 16px;
    color: #1d2541;
    margin-bottom: 20px;
    padding-left: 20px;
    position: relative;
    &:last-child {
      margin-bottom: 0;
    }
    .title {
      &::after {
        content: "";
        display: block;
        width: 8px;
        height: 8px;
        background-color: #409eff;
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .date {
      color: #9a9a9a;
      font-size: 13px;
      margin-left: 20px;
    }
  }
}
</style>